import { GET_COMPANY } from "@apiUtils";
import { mutationFetch } from "@atlas/sdk";
import type {
  IHubCheckLoginIdRequest,
  IHubCheckLoginIdResponse,
} from "@models";
import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export const hubCheckLoginId = async (
  companyUuid: string,
  request: IHubCheckLoginIdRequest,
  basePath?: string,
): Promise<IHubCheckLoginIdResponse> => {
  const path = `${GET_COMPANY}/${companyUuid}/check-loginId`;
  const url = basePath ? `${basePath.replace(/\/$/, "")}${path}` : path;
  return mutationFetch<IHubCheckLoginIdResponse>({
    url,
    method: "POST",
    body: request,
  });
};

export const useHubCheckLoginId = (
  companyUuid: string | undefined,
  basePath?: string,
  options?: Partial<
    UseMutationOptions<
      IHubCheckLoginIdResponse,
      AxiosError,
      IHubCheckLoginIdRequest,
      unknown
    >
  >,
) => {
  return useMutation({
    mutationFn: (request: IHubCheckLoginIdRequest) =>
      hubCheckLoginId(companyUuid ?? "", request, basePath),
    ...options,
  });
};
